export interface RateMarkupDto {
  debitWalletType: {
    id: 0
    name: string
  }
  debitCurrency: {
    id: string
    name: string
  }
  creditWalletType: {
    id: 0
    name: string
  }
  creditCurrency: {
    id: string
    name: string
  }
  id: string
  markup: number
  precision: number
}

export enum RateMarkupKey {
  debitWalletType = 'debitWalletType.name',
  debitCurrency = 'debitCurrency.id',
  creditWalletType = 'creditWalletType.name',
  creditCurrency = 'creditCurrency.id',
  markup = 'markup',
  precision = 'precision',
}

export enum RateMarkupFilterKey {
  debitWalletType = 'DebitWalletTypeId',
  debitCurrency = 'DebitCurrencyId',
  creditWalletType = 'CreditWalletTypeId',
  creditCurrency = 'CreditCurrencyId',
}
